export class SkylabConfig {

	public static get companyProductsUrl(): string {
		return 'https://mojekonto.insert.com.pl/';
	}

	public static get companyUrl(): string {
		return 'https://mojekonto.insert.com.pl/konto/moje_dane';
	}

	public static get firstStepsUrl(): string {
		return 'https://www.insert.com.pl/dla_uzytkownikow/e-pomoc_techniczna/3456,subiekt-123-zbior-zagadnien-e-pomocy-istotnych-przy-konfigurowaniu-i-rozpoczeciu-pracy.html';
	}

	public static get documentsByLocalSelfGovernmentForumUrl(): string {
		return 'https://www.insert.com.pl/dla_uzytkownikow/e-pomoc_techniczna/1964%2Csubiekt-123-jak-wystawic-fakture-przez-jednostke-samorzadu-terytorialnego.html';
	}

	public static get documentsForLocalSelfGovernmentForumUrl(): string {
		return 'https://www.insert.com.pl/dla_uzytkownikow/e-pomoc_techniczna/1968%2Csubiekt-123-jak-wystawic-fakture-dla-jednostki-samorzadu-terytorialnego.html';
	}

	public static get fiscalizationTutorialUrl(): string {
		return 'https://forum.insert.com.pl/index.php?/topic/582-konfiguracja-modu%C5%82u-fiskalizacji/';
	}

	public static get onlineReceiversConfigurationForumUrl(): string {
		return 'https://forum.insert.com.pl/index.php?/topic/588-konfiguracja-wymiany-dokument%C3%B3w-z-produktami-ksi%C4%99gowymi-insert-nexo/';
	}

	public static get suzDownloadUrl(): string {
		return 'https://www.insert.com.pl/subiekt_123_suz';
	}

	public static get landingPageUrl(): string {
		return 'https://subiekt123.pl/';
	}

	public static get advanceVatRateInfo(): string {
		return 'https://forum.insert.com.pl/index.php?/topic/18381-z';
	}

	public static get technicalSupportUrl(): string {
		return 'https://www.insert.com.pl/dla_uzytkownikow/e-pomoc_techniczna.html?program=20';
	}

	public static get subiekt123ForumUrl(): string {
		return 'https://forum.insert.com.pl/index.php?/forum/32-subiekt-123/';
	}

	public static get ksefTokenConfiguration(): string {
		return 'https://forum.insert.com.pl/index.php?/topic/85194-aktualizacja-subiekta-123-integracja-z-krajowym-systemem-e-faktur/&do=findComment&comment=431651';
	}

	public static get contactForm(): string {
		return 'https://www.insert.com.pl/dla_uzytkownikow/formularz_kontaktowy.html';
	}

	public static get ksefCertificateInfo(): string {
		return 'https://ksef.podatki.gov.pl/informacje-ogolne-ksef-20/certyfikaty-ksef'
	}
}
